import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Checkbox, Divider, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material'
import { RootState } from '../../../global/config/store.ts';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ApiCreateBundleAllocation, ApiGetAllocationlist, ApiGetBundleList, ApiGetClientEntityByClientGroupId, ApiGetOrphanAllocations, ApiUpdateBundleAllocation } from '../../../apiService/Core/Apicall.tsx';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { format } from 'date-fns';
import { CancelOutlined } from '@mui/icons-material';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import { setDate } from '../../../global/config/Reducer/dateSlice.ts';
import { monthsData } from '../../../global/constants/globalContants.ts';

const stateOptions = [
    { label: "Victoria", value: "VIC" },
    { label: "Western Australia", value: "WA" },
    { label: "South Australia", value: "SA" },
    { label: "Queensland", value: "QLD" },
    { label: "Australian Capital Territory", value: "ACT" },
    { label: "New South Wales", value: "NSW" },
    { label: "Tasmania", value: "TAS" },
    { label: "Northern Territory", value: "NT" },
];

function CreateBundleAllocation() {
    // debugger
    const location = useLocation();
    const { id,currentdate } = useParams()
    // const bundleData = location.state?.bundleData;
    // const currentData = location.state?.currentDate;
    const [bundleData, setBundleData] = useState<any>()
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const [clientEntityId, setClientEntityId] = useState<any>(null);
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
    const [ClientId, setClientId] = useState(null);
    const [currentDate, setCurrentDate] = useState(currentdate ? new Date (currentdate) : new Date(selectedDateRedux));
    const [reportMonth, setReportMonth] = useState<number>(new Date(currentDate).getMonth() + 1);
    const [reportYear, setReportYear] = useState<number>(new Date(currentDate).getFullYear());
    const [monthly, setMonthly] = useState([])

    // const [checkboxes, setCheckboxes] = React.useState<any[]>([]);
    const [checkboxes, setCheckboxes] = React.useState<{ [key: number]: boolean }>({});
    const [task, settask] = React.useState<any[]>([]);
    const [filteredTasks, setfilteredTasks] = React.useState<any>(task);
    const [bundleTasks, setbundleTasks] = React.useState<any[]>(
        bundleData?.venue ? bundleData.venue : []
    );
    const [bundleName, setbundleName] = React.useState<string>(bundleData && bundleData.bundleName ? bundleData.bundleName : '');
    const navigate = useNavigate()
    const [selectedState, setSelectedState] = useState("");


    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])


    const ApiBundleAllocation = async () => {
        settask([])
        let data = `?jobMonth=${reportMonth}&jobYear=${reportYear}&bundleId=${id}`
        try {
            const response = await ApiGetBundleList(data)
            setBundleData(response.data[0])
            setbundleName(response?.data[0]?.bundleName)

        } catch (error) {
            alert(error)
        }

    }

    useEffect(()=>{
        id && reportMonth && reportYear &&  ApiBundleAllocation()
    },[id])

    // const handleChange = (taskId: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const checked = event.target.checked;

    //     setCheckboxes((prev) => (
    //         {
    //             ...prev,
    //             [taskId]: event.target.checked

    //         }));
    //     if (!checked) {
    //         setbundleTasks((prev) =>
    //             prev.filter((item) => item.venueId !== taskId)
    //         );
    //     }

    // };
    // useEffect(() => {
    //     bundleData?.venue.map((item) => {
    //         setCheckboxes((prev) => (
    //             {
    //                 ...prev,
    //                 [item?.venueId]: true

    //             }));
    //     })
    // }, [bundleData])
    const handleChange = (allocationId: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        setCheckboxes((prev) => ({
            ...prev,
            [allocationId]: checked
        }));
        if (!checked) {
            setbundleTasks((prev) =>
                prev.filter((item) => item.allocationId !== allocationId)
            );
        }
    };
    useEffect(() => {
        if (bundleData?.venue) {
            const initialCheckboxes: { [key: number]: boolean } = {};
            bundleData.venue.forEach(item => {
                initialCheckboxes[item.allocationId] = true;
            });
            setCheckboxes(initialCheckboxes);
        }
    }, [bundleData]);

    // useEffect(() => {
    //     if (bundleData?.venue) {
    //         const initialCheckboxes: { [key: number]: boolean } = {};
    //         bundleData.venue.forEach(item => {
    //             initialCheckboxes[item.venueId] = true;
    //         });
    //         setCheckboxes(initialCheckboxes);
    //     }
    // }, [bundleData]);





    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);

    useEffect(() => {
        if (clientEntityList.length > 1) {
            setClientEntityId(clientEntityList[0]?.clientEntityId);
        }
    }, [clientEntityList]);


    useEffect(() => {
        if (!clientEntityId) {
            settask([])
            return;
        }
        const getallocationlist = async () => {
            settask([])
            const data = `?offset=0&limit=1000&jobMonth=${reportMonth}&jobYear=${reportYear}&allocationClientGroup=${selectedClient?.clientGroupName}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}${selectedState ? `&state=${selectedState}` : ""}`
            try {
                const response = await ApiGetOrphanAllocations(data)
                const filteredAllocations = response.data.filter((allocation: any) => allocation.bundleId === null)
                settask(filteredAllocations)
            } catch (error) {
                alert(error)
            }
        }
        getallocationlist()
    }, [reportMonth, reportYear, clientEntityId, selectedClient, clientEntityList.length, selectedState])

    // useEffect(() => {
    //     handleGetClientList();
    // }, [ClientId]);
    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])

    // useEffect(() => {
    //     settask([])
    //     const getallocationlist = async () => {
    //         // const data = `?allocationStatus=created&offset=0&limit=1000&jobMonth=${reportMonth}&jobYear=${reportYear}&allocationClientGroup=${selectedClient?.clientGroupName}&clientEntityId=${clientEntityId}`
    //         const data = `?offset=0&limit=1000&jobMonth=${reportMonth}&jobYear=${reportYear}&allocationClientGroup=${selectedClient?.clientGroupName}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}`
    //         try {
    //             const response = await ApiGetOrphanAllocations(data)
    //             settask(response.data)

    //         } catch (error) {
    //             alert(error)
    //         }
    //     }
    //     getallocationlist()
    // }, [reportMonth, reportYear, clientEntityId, selectedClient])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`;
        if (!selectedClient?.clientGroupName) return;
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data);
            setClientEntityList(res.data);
        } catch (error) {
        }
    };
    const handlePrevMonth = () => {
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");

            if (isEmptyBundle) {
                setCurrentDate((prevDate) => {
                    const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
                    setReportMonth(newDate.getMonth() + 1);
                    setReportYear(newDate.getFullYear());
                    dispatch(setDate(newDate))
                    return newDate;
                });
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate((prevDate) => {
                const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                dispatch(setDate(newDate))
                return newDate;
            });
        }
    };

    const handleNextMonth = () => {
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");
            if (isEmptyBundle) {
                setCurrentDate((prevDate) => {
                    const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
                    setReportMonth(newDate.getMonth() + 1);
                    setReportYear(newDate.getFullYear());
                    dispatch(setDate(newDate))
                    return newDate;
                });
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate((prevDate) => {
                const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                dispatch(setDate(newDate))
                return newDate;
            });
        }
    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01");
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");
            if (isEmptyBundle) {
                setCurrentDate(newDate);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                dispatch(setDate(event.target.value))
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate(newDate);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            dispatch(setDate(event.target.value))
        }
    };

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    // useEffect(() => {
    //     const filtered = task.filter((item) => checkboxes[item.allocationId])
    //     setbundleTasks(filtered)
    // }, [checkboxes, task])

    // useEffect(() => {
    //     const filtered = task.filter((item) => checkboxes[item.venueId.venueId]);
    //     console.log("Filtered", filtered)

    //     setbundleTasks((prev) => {
    //         // Create a Map to avoid duplicates based on allocationId
    //         const existingMap = new Map(prev.map(item => [bundleData ? item?.venueId : item.venueId.venueId, item]));


    //         // Add or update with new filtered items
    //         // filtered.forEach(item => {
    //         //     existingMap.set(bundleData ? item?.venueId : item.venueId.venueId, item);
    //         // });
    //         filtered.forEach((item) => {
    //             existingMap.set(item.venueId.venueId, {
    //                 venueId: item.venueId.venueId,
    //                 venueName: item.venueId.venueName,
    //             });
    //         });

    //         return Array.from(existingMap.values());
    //     });
    // }, [checkboxes, task]);

    // useEffect(() => {
    //     const filtered = task.filter((item) => checkboxes[item?.venueId?.venueId]);

    //     // setbundleTasks(

    //     //     filtered.map((item) => ({
    //     //         allocationId: item.allocationId,
    //     //         venueId: item.venueId.venueId,
    //     //         venueName: item.venueId.venueName,
    //     //         taskName: item.taskName,
    //     //     }))
    //     // );

    //     setbundleTasks((prev) => [
    //         ...prev,
    //         ...filtered.map((item) => ({
    //             allocationId: item.allocationId,
    //             venueId: item.venueId.venueId,
    //             venueName: item.venueId.venueName,
    //             taskName: item.taskName,
    //         }))
    //     ]);
    // }, [checkboxes, task]);

    useEffect(() => {
        const filtered = task.filter((item) => checkboxes[item?.allocationId]);
        setbundleTasks((prev) => [
            ...prev,
            ...filtered.map((item) => ({
                allocationId: item.allocationId,
                venueId: item.venueId.venueId,
                venueName: item.venueId.venueName,
                taskName: item.taskName,
            }))
        ]);
    }, [checkboxes, task]);
    // useEffect(() => {
    //     const selectedFromTasks = task
    //         .filter((item) => checkboxes[item?.venueId?.venueId])
    //         .map((item) => ({
    //             allocationId: item?.allocationId,
    //             venueId: item?.venueId.venueId,
    //             venueName: item?.venueId?.venueName,
    //             taskName: item?.taskName,
    //         }));
    //     // console.log("Selected From Task", selectedFromTasks)
    //     const selectedFromBundleData = (bundleData?.venue || [])
    //         .filter((item) => checkboxes[item?.venueId])
    //         .map((item) => ({
    //             allocationId: item?.allocationId,
    //             venueId: item?.venueId,
    //             venueName: item?.venueName,
    //             taskName: item?.taskName,
    //         }));
    //     // console.log("Selected From Bundl Data", selectedFromBundleData)


    //     const merged = new Map();
    //     [...selectedFromTasks, ...selectedFromBundleData].forEach((item) =>
    //         merged.set(item.venueId, item)
    //     );

    //     // setbundleTasks(Array.from(merged.values()));
    //     setbundleTasks((prev) => {
    //         const mergedMap = new Map();

    //         // Keep old items
    //         prev.forEach((item) => mergedMap.set(item?.venueId, item));

    //         // Add / update new selections
    //         [...selectedFromTasks, ...selectedFromBundleData].forEach((item) =>
    //             mergedMap.set(item?.venueId, item)
    //         );

    //         return Array.from(mergedMap.values());
    //     });
    // }, [checkboxes, task, bundleData]);

    useEffect(() => {
        const selectedFromTasks = task
            .filter((item) => checkboxes[item?.allocationId])
            .map((item) => ({
                allocationId: item?.allocationId,
                venueId: item?.venueId.venueId,
                venueName: item?.venueId?.venueName,
                taskName: item?.taskName,
                clientEntityId: item?.clientEntityId?.clientEntityId || item?.venueId?.clientEntityId?.clientEntityId,
            }));

        const selectedFromBundleData = (bundleData?.venue || [])
            .filter((item) => checkboxes[item?.allocationId])
            .map((item) => ({
                allocationId: item?.allocationId,
                venueId: item?.venueId,
                venueName: item?.venueName,
                taskName: item?.taskName,
                clientEntityId: item?.clientEntityId?.clientEntityId,
            }));

        setbundleTasks((prev) => {
            const mergedMap = new Map();
            prev.forEach((item) => mergedMap.set(item?.allocationId, item));
            [...selectedFromTasks, ...selectedFromBundleData].forEach((item) =>
                mergedMap.set(item?.allocationId, item)
            );
            return Array.from(mergedMap.values());
        });
    }, [checkboxes, task, bundleData]);

    const removeBundle = (allocationId: number) => {
        const filteredBundle = bundleTasks.filter(item => item?.allocationId !== allocationId)
        setbundleTasks(filteredBundle)
        setCheckboxes((prev) => ({
            ...prev,
            [allocationId]: false
        }));
    }
    const createbundle = async () => {
        if (bundleName !== '' && bundleTasks.length > 0) {
            const commonClientEntityId = checkIfSameClientEntity(bundleTasks);
            const data = {
                bundleName: bundleName,
                months: monthly,
                year: reportYear,
                clientGroupName: selectedClient?.clientGroupName,
                clientEntityId: commonClientEntityId,
                allocations: bundleTasks.map(item => ({
                    // allocationId: item.allocationId,
                    venueIds: String(item.venueId)
                }))
            }
            const data2 = {
                bundleName: bundleName,
                month: reportMonth,
                year: reportYear,
                clientGroupName: selectedClient?.clientGroupName,
                clientEntityId: commonClientEntityId,
                allocations: bundleTasks.map(item => ({
                    allocationId: item.allocationId,
                    venueIds: String(item.venueId)
                }))
            }
            // try {
            //     const response = await ApiCreateBundleAllocation(data);
            //     if (response.status) {
            //         navigate('/admin/allocations/bundle-allocations')
            //     }
            //     alert(response.message)
            // } catch (error) {
            //     alert(error)
            // }
            try {
                let response;

                if (bundleData) {
                    //  Update bundle
                    response = await ApiUpdateBundleAllocation({
                        ...data2,
                        bundleId: bundleData.bundleId,
                    });
                } else {
                    //  Create new bundle
                    if (monthly?.length > 0) {
                        response = await ApiCreateBundleAllocation(data);
                    }
                    else {
                        alert('Select month to create bundle')
                    }
                }

                if (response?.status) {
                    setMonthly([])
                    navigate('/admin/allocations/bundle-allocations');
                }

            } catch (error) {
                alert(error);
            }
        }
        else if (bundleName == '') {
            alert('Enter Bundle Name')
        }
        else if (bundleTasks.length == 0) {
            alert('Select allocations to create bundle')
        }
        else if (monthly.length == 0) {
            alert('Select month to create bundle')
        }
    }

    const checkIfSameClientEntity = (allocations: any[]) => {
        if (allocations.length === 0) return null;

        const getEntityId = (item: any) => {
            if (typeof item?.clientEntityId === 'number') {
                return item.clientEntityId;
            }
            if (typeof item?.clientEntityId === 'object' && item?.clientEntityId?.clientEntityId) {
                return item.clientEntityId.clientEntityId;
            }
            return null;
        };

        const firstClientEntityId = getEntityId(allocations[0]);

        if (!firstClientEntityId) return null;

        const allSame = allocations.every(
            (allocation) => getEntityId(allocation) === firstClientEntityId
        );

        return allSame ? firstClientEntityId : null;
    };

    return (
        <Box className='bg-white pt-5'>
            <div className="d-flex align-items-center justify-content-between px-3 mb-1">
                <Box className='d-flex align-items-center gap-5'>
                    <Stack direction="row" className="" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={Clientlist}
                                value={selectedClient}
                                getOptionLabel={(option) => option?.clientGroupName}
                                isOptionEqualToValue={(option, value) =>
                                    option.clientGroupDBName === value.clientGroupDBName
                                }
                                onChange={(event, newValue: any) => {
                                    // setSelectedClient(newValue);
                                    dispatch(setSelectedClientGroup(newValue))
                                    setClientId(newValue?.clientGroupName || null);
                                    setClientEntityId(null)
                                    setClientEntityList([])
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack className="ml-2" direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clientEntityList.filter(
                                    (item) => item.clientEntityId !== null
                                )} // filter out invalid entries
                                getOptionLabel={(option) => option?.entityName || ""} // properly show label
                                onChange={(event, newValue: any) => {
                                    setClientEntityId(newValue?.clientEntityId || null);
                                }}
                                value={
                                    clientEntityList.find(
                                        (option) => option?.clientEntityId === clientEntityId
                                    ) || null
                                }
                                defaultValue={clientEntityList[0]?.clientEntityId}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Business" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack className="ml-2" direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                options={stateOptions}
                                value={
                                    stateOptions.find((state) => state.value === selectedState) ||
                                    null
                                }
                                getOptionLabel={(option) => option.label}
                                onChange={(event, newValue) => {
                                    setSelectedState(newValue ? newValue.value : "");
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select State" fullWidth />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                </Box>
                <h1 className="">Bundle Allocations</h1>

                {/* <Box className='col-6 d-flex juastify-content-start'> */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // marginTop: "20px"
                    }}
                >
                    <IconButton onClick={handlePrevMonth}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                        <input
                            type="month"
                            onChange={handleDateChange}
                            value={format(currentDate, "yyyy-MM")}
                            className="primary-color"
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "1.25rem",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontFamily: "inherit",
                            }}
                        />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
                {/* </Box> */}
                {/* <div className="add-button common-manage-button">
                    <Button
                        variant="contained"
                        onClick={() => addOrUpdateVenue()}
                        className="table-row-background "
                    >
                        Add New Site
                    </Button>
                   
                </div>{" "} */}
            </div>
            <Divider className='mx-4 mb-2' />

            <Box height='calc(100vh - 380px)' className='d-flex align-items-start  justify-content-between'>
                <Box className='col-8 h-100 p-3'>
                    <Box className='d-flex flex-wrap align-items-center justify-content-start' maxHeight='calc(100vh - 450px)' overflow='auto' gap={2}>
                        {task.length > 0 ? task.map((item: any) => (
                            <Box className='border d-flex align-items-start p-2 col-3' sx={{ borderRadius: '10px' }} maxWidth='24%' gap={1} key={item.allocationId}>
                                {/* <Checkbox
                                    className='m-0 p-0'
                                    checked={checkboxes[item?.venueId?.venueId] || false}
                                    onChange={handleChange(item?.venueId?.venueId)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                /> */}
                                <Checkbox
                                    className='m-0 p-0'
                                    checked={checkboxes[item?.allocationId] || false}
                                    onChange={handleChange(item?.allocationId)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <Box>
                                    <Typography lineHeight='1' className='fw-bold m-0 p-0' variant='h6'>{item?.venueId?.venueName}</Typography>
                                    <Typography className='m-0 p-0' variant='subtitle2'>{item?.taskName}</Typography>
                                </Box>
                            </Box>

                        )) : <Typography variant='h6' className='text-center w-100'>Allocations not Found</Typography>}
                    </Box>
                </Box>
                <Divider orientation='vertical' />
                <Box className='col-4 h-100 p-3'>
                    <Typography className='text-center mb-3' variant='h5'>Selected Allocation</Typography>
                    <Box className='d-flex flex-wrap align-items-center' maxHeight='calc(100vh - 450px)' overflow='auto' gap={1}>
                        {bundleTasks && bundleTasks.map(item => (
                            <Box className='border d-flex align-items-start justify-content-between p-3 col-6' sx={{ borderRadius: '10px' }} maxWidth='49%' key={item.allocationId}>
                                <Box>
                                    <Typography lineHeight='1' className='fw-bold m-0 p-0' variant='h6'>{item?.venueName}</Typography>
                                    <Typography className='m-0 p-0' variant='subtitle2'>{item.taskName}</Typography>
                                </Box>
                                {/* <IconButton className='p-0' onClick={() => { removeBundle(item?.venueId) }}><CancelOutlined className='p-0' /></IconButton> */}
                                <IconButton className='p-0' onClick={() => { removeBundle(item?.allocationId) }}>
                                    <CancelOutlined className='p-0' />
                                </IconButton>
                            </Box>

                        ))}
                    </Box>
                </Box>
            </Box>
            <Divider className='mx-4 my-3' />
            <Box className='d-flex px-3 align-items-center justify-content-end' gap={2}>
                {!bundleData && (<FormControl size="medium" className='mb-3' sx={{ minWidth: 150 }}>
                    <Select
                        style={{ width: "200px" }}
                        multiple
                        value={monthly}
                        displayEmpty
                        onChange={(event: any) => {
                            setMonthly(event.target.value)
                        }}
                        renderValue={(selected) =>
                            selected.length === 0
                                ? "Monthly Bundle"
                                : selected.map((id) => monthsData.find((m) => m.id === id)?.label).join(", ")
                        }
                    >
                        {monthsData.map((items) => (
                            <MenuItem key={items.id} value={items.id}>
                                {items.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>)}
                <FormControl className="w-25 my-0 mb-3 ">
                    {/* <InputLabel shrink={false}>Bundle Name: </InputLabel> */}
                    <TextField
                        className="w-100"
                        label="Bundle Name"
                        placeholder="Enter Bundle Name..."
                        variant="outlined"
                        fullWidth
                        value={bundleName}
                        onChange={(e) => setbundleName(e.target.value)}
                    />
                    {/* { && <Typography className="text-danger">{formik.errors.questions}</Typography>} */}

                </FormControl>
                <Box className='extra'>
                    <Button className="bg-grey transform px-5 text-light" onClick={() => { createbundle() }}>
                        {bundleData ? `Update` : `Create`}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default CreateBundleAllocation
